import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import { useStore } from 'core/store/store.mobx';

import useStyles from './recalculating-dim.styles';

const RecalculatingDim = observer(({ id, className, children }) => {
  const { offer: store } = useStore();
  const classes = useStyles();

  return (
    <fieldset
      id={id}
      disabled={store.recalculatingPrice}
      className={classNames(classes.fieldset, className, {
        [classes.recalculatingContent]: store.recalculatingPrice
      })}
      aria-busy={store.recalculatingPrice}
    >
      {children}
    </fieldset>
  );
});

RecalculatingDim.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default RecalculatingDim;
